import {
  AtrStatusCategory,
  ClientPortalStatusCategory,
  ContactATRECQStatusEnum,
  OneviewContactEcqStatusChoices,
  OneviewDocumentSignatureRequestStatusChoices,
} from '../../schema-types/globalTypes';
import {themeColors} from '../../theme/Theme';

export const atrStatusCategoryColors: Record<
  AtrStatusCategory | ContactATRECQStatusEnum,
  string
> = {
  closed: themeColors.lightBlue,
  // amended_not_pending: themeColors.blue,
  amended_pending: themeColors.grey,
  completed: themeColors.lightGreen,
  not_started: themeColors.lightWarning,
  pending: themeColors.lightAlert,
  manual: themeColors.lightGreen,
  IN_DATE: themeColors.lightGreen,
  MISSING: themeColors.lightWarning,
  OUTDATED: themeColors.lightAlert,
  SENT: themeColors.lightAlert,
  UP_TO_DATE: themeColors.lightGreen,
};
export const atrStatusCategoryText: Record<AtrStatusCategory, string> = {
  // amended_not_pending: 'Amended not pending',
  closed: 'Closed',
  amended_pending: 'Amended & pending',
  completed: 'Completed',
  not_started: 'Not started',
  pending: 'Pending',
  manual: 'Completed',
};

export const ecqStatusCategoryColors: Record<OneviewContactEcqStatusChoices, string> = {
  IN_DATE: themeColors.lightGreen,
  MISSING: themeColors.lightWarning,
  OUTDATED: themeColors.lightAlert,
  SENT: themeColors.lightAlert,
  UP_TO_DATE: themeColors.lightGreen,
};
export const ecqStatusCategoryText: Record<OneviewContactEcqStatusChoices, string> = {
  IN_DATE: 'In-date',
  MISSING: 'Missing',
  OUTDATED: 'Outdated',
  SENT: 'Sent',
  UP_TO_DATE: 'Up-to-date',
};

export const fpaStatusCategoryColors: Record<
  OneviewDocumentSignatureRequestStatusChoices,
  string
> = {
  PENDING: themeColors.lightPurple,
  FAILED: themeColors.lightWarning,
  SENT: themeColors.lightAlert,
  SIGNED: themeColors.lightGreen,
  CANCELLED: themeColors.lightWarning,
};
export const fpaStatusCategoryText: Record<
  OneviewDocumentSignatureRequestStatusChoices,
  string
> = {
  FAILED: 'Failed',
  PENDING: 'Pending',
  SENT: 'Sent',
  SIGNED: 'Signed',
  CANCELLED: 'Cancelled',
};

export const clientPortalStatusCategoryColors: Record<
  ClientPortalStatusCategory,
  string
> = {
  archived: themeColors.grey,
  compromised: themeColors.red,
  confirmed: themeColors.lightGreen,
  force_change_password: themeColors.lightWarning,
  not_started: themeColors.lightAlert,
  reset_required: themeColors.lightAlert,
  unconfirmed: themeColors.lightAlert,
  unknown: themeColors.grey,
  does_not_exist: themeColors.coral,
};
export const clientPortalStatusCategoryText: Record<ClientPortalStatusCategory, string> =
  {
    archived: 'Archived',
    compromised: 'Compromised',
    confirmed: 'Confirmed',
    force_change_password: 'Force change password',
    not_started: 'Not started',
    reset_required: 'Reset required',
    unconfirmed: 'Unconfirmed',
    unknown: 'Unknown',
    does_not_exist: 'Does not exist',
  };
